export const normalizeFabricLabel = (fabricLabel: string) => {
  if (typeof fabricLabel !== 'string' || !fabricLabel) return '';

  return fabricLabel.slice(-8) === '-default' ? fabricLabel.slice(0, -8) : fabricLabel;
};
